<template>
  <MediaTwoColumnTheme :theme="configuration">
    <section
      :class="{
        'media-two-column-component': true,
      }"
    >
      <div
        :class="{
          'container mx-auto': true,
        }"
      >
        <div
          :class="{
            'grid grid-cols-12 content-center gap-y-30px md:gap-30px': true,
          }"
        >
          <div :class="primaryColumnClasses">
            <BlockTheme :theme="configuration?.primaryBlock">
              <PrimaryBlock
                v-if="mediaTwoColumn && mediaTwoColumn.primaryBlock"
                v-bind="mediaTwoColumn.primaryBlock"
              />
            </BlockTheme>
          </div>
          <div :class="secondaryColumnClasses">
            <BlockTheme :theme="configuration?.secondaryBlock">
              <SecondaryBlock
                v-if="mediaTwoColumn && mediaTwoColumn.secondaryBlock"
                v-bind="mediaTwoColumn.secondaryBlock"
              />
            </BlockTheme>
          </div>
        </div>
      </div>
    </section>
  </MediaTwoColumnTheme>
</template>

<script setup lang="ts">
import type { MediaTwoColumnPrimaryBlock, PortableTextMediaTwoColumn } from '~/sanity/types';
const props = defineProps<PortableTextMediaTwoColumn>();

type WidthType = NonNullable<MediaTwoColumnPrimaryBlock['width']>;

//Initialize widths dynamically based on props or logic
const primaryWidth = ref<WidthType>(props.mediaTwoColumn?.primaryBlock?.width || '6'); // Fallback to default if no width is provided
const primaryAlignment = ref<string>(props.mediaTwoColumn?.primaryBlock?.alignment || 'left'); // Fallback to default if no width is provided
const secondaryWidth = computed(() => 12 - Number(primaryWidth.value)); // Dynamically calculate secondary width

const primaryColumnClasses = computed(() => ({
  [widthStyles[primaryWidth.value]]: true,
  [alignmentStyles[primaryAlignment.value]]: true,
  'content-center col-span-12': true,
}));
const secondaryColumnClasses = computed(() => ({
  [widthStyles[secondaryWidth.value]]: true,
  [alignmentSecodaryStyles[primaryAlignment.value]]: true,
  'content-center col-span-12': true,
}));

const widthStyles: Record<string, string> = {
  '1': 'lg:col-span-1',
  '2': 'lg:col-span-2',
  '3': 'lg:col-span-3',
  '4': 'lg:col-span-4',
  '5': 'lg:col-span-5',
  '6': 'lg:col-span-6',
  '7': 'lg:col-span-7',
  '8': 'lg:col-span-8',
  '9': 'lg:col-span-9',
  '10': 'lg:col-span-10',
  '11': 'lg:col-span-11',
};

const alignmentStyles: Record<string, string> = {
  left: 'lg:order-0',
  right: 'lg:order-1',
};
const alignmentSecodaryStyles: Record<string, string> = {
  left: 'lg:order-1',
  right: 'lg:order-0',
};
</script>
